import { inject, Injectable } from '@angular/core';
import {
  CorporateMethodsService,
  SwitchingAccountService
} from '@com-delta-idp/mnx-capability-profile-selector-smart';
import {
  FooterColumnDetails,
  FooterColumnItem
} from '@com-delta-idp/mnx-sitewide-footer-ui';
import {
  AppConfigService,
  CommonService,
  ExtendedCookieHelperUtilsService,
  HeaderFooterMachCore,
  HeaderFooterMachCoreContentService,
  TabItem,
  UrlUtilsService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';

@Injectable({
  providedIn: 'root'
})
export class FooterHelperAdapterService {
  appconfig = inject(AppConfigService);
  commonService = inject(CommonService);
  corporateMethodService = inject(CorporateMethodsService);
  switchingAccountService = inject(SwitchingAccountService);
  headerFooterContentService = inject(HeaderFooterMachCoreContentService);
  cookieHelper = inject(ExtendedCookieHelperUtilsService);
  urlUtil = inject(UrlUtilsService);

  getFooterColumnItems(
    headerFooterDetails: HeaderFooterMachCore
  ): FooterColumnDetails[] {
    const footerColDetails = headerFooterDetails.footer.footercolumns.map(
      (column) => {
        return {
          heading: column.tabcolheading,
          item: this.getColumnItem(column.tabcolItems)
        };
      }
    );
    return footerColDetails;
  }

  getColumnItem(columnItems: TabItem[]): FooterColumnItem[] {
    const colItems = columnItems.map((columnItem: TabItem) => {
      return {
        newWindow: columnItem.tabnewwindow === 'true',
        itemName: columnItem.tabitemtext,
        itemUrl: columnItem.tabitemUrl,
        externalImage: columnItem.externalimage === 'true'
      };
    });
    return colItems;
  }
}
